export const formatAmount = (
    value: number,
    maximumFractionDigits = 0,
    addCurrency = false,
    forcePositive = false,
): string => {
    if (typeof value === 'undefined') {
        return '';
    }

    const valueToFormat = forcePositive ? Math.abs(value) : value;

    let minimumFractionDigits = 0;

    if (maximumFractionDigits >= 2) {
        minimumFractionDigits = 2;
    }

    const nf = new Intl.NumberFormat('no-NO', { minimumFractionDigits, maximumFractionDigits });
    const numberDisplay = nf.format(valueToFormat);

    if (addCurrency) {
        return `${numberDisplay} kr`;
    }

    return numberDisplay;
};
